import React, { Component } from "react";
import WidgetPageRenderer from "../widgets/WidgetPageRenderer";

import LoadingOverlay from "./LoadingOverlay";
export default class Table_form_mapping_NEW extends Component {
  render() {
    return <WidgetPageRenderer pageRoute="table_form_mapping" />;
  }
}
